import { Button, Typography } from 'antd';

import styled, { css, StyledProp } from '@/styled';

const PasswordProducer: React.FC = ({ className }: StyledProp) => {
  return (
    <div className={className}>
      <Typography.Paragraph className='password-producer-textPassword'>
        Para alterar sua senha, clique no botão abaixo para que você seja direcionado ao MyEduzz e dê andamento na troca
        da sua senha.
      </Typography.Paragraph>
      <a href={'https://orbita.eduzz.com/producer/profile/edit'} target='_blank' rel='noreferrer'>
        <Button size='large' className='password-producer-link' type='primary'>
          Alterar Senha
        </Button>
      </a>
    </div>
  );
};

export default styled(PasswordProducer)(
  ({ theme }) => css`
    .password-producer-textPassword {
      color: ${theme.colorTextSecondary};
    }

    .password-producer-link {
      background-color: ${theme.colorText};

      ${theme.breakpoints.down('md')} {
        width: 100%;
      }
    }
  `
);
